<div class="dialog-container">
    <div class="dialog-header">
        <div class="left-section">
            <div class="heading">
                {{dialogLabel | translate}}
            </div>

            <div class="description">
                {{dialogDescription | translate}}
            </div>

        </div>
        <div class="right-section">
            <div class="close-icon">
                <app-icon path="assets/images/common/cross-icon.svg" (click)="onClose()"></app-icon>
            </div>
        </div>
    </div>
    <div class="dialog-content">
        <div class="billing-toggle-wrap">
            <div class="billing-toggle">
                <span [class.active]="!isAnnualBilling">{{ 'monthly' | translate }}</span>
                <app-switch-field [checked]="isAnnualBilling"
                    (checkedChange)="toggleBillingCycle($event)"></app-switch-field>
                <span [class.active]="isAnnualBilling">{{ 'annual' | translate }}</span>
            </div>
        </div>

        <div class="dialog-card section-bordered-shadow" *ngFor="let plan of plans" (click)="onSelectPlan(plan)"
            [class.active]="currentPlan === plan.id">
            <div class="card-content">
                <div class="card-title">
                    {{plan.name}}
                    <span *ngIf="plan.isRecommended">{{ 'register.plan.recommended' | translate }}</span>
                </div>
                <div class="card-price">
                    {{getDisplayPrice(plan) }}
                    <span>
                        {{getDisplayPeriod()}}
                    </span>
                </div>
                <div class="card-subprice" *ngIf="getMonthlyEquivalent(plan)">{{ getMonthlyEquivalent(plan) }}</div>
                <div class="card-note">{{ getBillingNote() | translate }}</div>
                <div class="card-chip" *ngIf="getAnnualSavingsLabel(plan)">{{ getAnnualSavingsLabel(plan) }}</div>
                <div class="card-info">
                    <div class="info-title" *ngFor="let label of getPlanLimitLabels(plan)">{{ label }}</div>
                </div>
                <div class="card-options">
                    <div class="option-desc">
                        <ul>
                            <li *ngFor="let point of getPlanFeatureLabels(plan)">
                                <img src="assets/images/settings/tick-green.svg" alt="">
                                {{point}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="card-selector">
                <label class="custom-radio">
                    <input type="radio" name="plan" [checked]="currentPlan === plan.id" />
                    <span class="radio-ui"></span>
                </label>
            </div>


        </div>

    </div>

    <div class="dialog-footer">
        <button class="rounded-btn black" (click)="onClose()">{{ 'cancel' | translate}}</button>
        <button class="rounded-btn primary-gradient" (click)="handleChangeSubscription()">{{ confirmChangeBtnLabel |
            translate}}</button>
    </div>
</div>
